<template>
  <div class="redis_info_list">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
    </div>
    <div class="redis_content" :style="`height: ${windowHeight - 180}px;`">
      <div class="redis_key_box">
        <pre>{{redisJson}}</pre>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {redisDetail} from '@/api/commonTool'

  export default {
    name: "redisManageInfo",
    data() {
      return {
        redisKey: this.$route.query.key,
        redisJson: {}
      }
    },
    created() {
      this.redisDetail();
    },
    mixins: [windowResize],
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      redisDetail() {
        redisDetail({
          redisKey: this.redisKey
        }).then(data => {
          this.redisJson = data ? (data[0] === '{' ? JSON.stringify(JSON.parse(data), null, 2) : data) : {};
        })
      }
    }
  }
</script>

<style lang="scss">
  @import './../../styles/mixin';

  .redis_info_list {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .redis_content {
      @include scrollBar;

      .redis_key_box {
        /*width: 810px;*/
        /*margin: 0 auto;*/
        padding: 10px;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/commonTool/redisManageInfo.vue